export const messages = {
    changepasswordSuccess: 'Password Change Successful.',
    depoWithdrawSuccess: 'Sucessfull Balance Transfer'

}

export const MESSAGE_MAP: any = {
    // 'transaction code not valid': 'Master password not valid',
    // 'invalid transaction': 'Master password not valid',
    'user not found': 'User does not exist',
    'Zero settlement Amount': 'Amount Greater then P/L',
};